module.exports = __webpack_public_path__ + "assets/img/48ab52519d77853e95c20d5fec10cab8.png";